import { APICalls } from '@power-core/toolkit';

export const API = (endpointURL?: string): APICalls => new APICalls(endpointURL ?? '/api/api', { headers: { 'X-Strapi-Request': 'true' } });
